import axios from "axios";
// import {
//   DrPartiStats,
//   DrItemStats,
//   DrStats,
//   GetDrExcelReport200Response as getDrExcelReport,
// } from "./api";
import { defs } from "@common/const_defs";
import { ContactUsData } from "@data/contact-us";

const getBasePath = (): string => {
  // const host = window.location.host.replace(/:\d+$/, "");
  // const ary = ["localhost", "127.0.0.1"];
  // if (ary.includes(host)) {
  //   return `http://${host}:8110`;
  // }
  return `https://api-uds.zerone-inf.com`;
};
export const post_contact_us_mail = async (
  data: ContactUsData,
): Promise<boolean> => {
  let rst = true;
  try {
    const url = `${getBasePath()}/func/forwardEmail`;
    const cfg = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    let content = "From: " + data.name + "\n";
    content += "Email: " + data.email + "\n";
    content += "Subject: " + data.subject + "\n\n";
    content += "Content:\n" + data.body;
    const body = {
      addr_to: [
        defs.kContactUsEmail,
        "skonta@open-quant.com",
        "chemoor@live.com",
      ],
      subject: "問合せ：" + data.subject,
      content: content,
    };
    const resp = await axios.post(url, body, cfg);
    rst = resp.data;
  } catch (err) {
    console.log(err);
    rst = false;
  }
  return rst;
};
